module.exports = __webpack_public_path__ + "static/stack-overflow-4c535a82b7dd308cbbad8e99f1dbc968.png";